const _ = require("lodash");
const moment = require("moment-timezone");
const { TZ } = require("./constants");

const titleCase = (str = "", exceptions = []) => {
  const allExceptions = [
    "of",
    "the",
    "and",
    "vs",
    "by",
    "at",
    "a",
    ...exceptions,
  ];

  // const regexExceptions =
  //   "(?<=\\s)(?<![?!.]\\s)(" + allExceptions.join("|") + ")(?=\\s)"
  // const regex = new RegExp(regexExceptions, "gi")

  // const startCaseStr = str.replace(/\w+/g, _.capitalize)
  // return startCaseStr.replace(regex, _.lowerCase)
  let tittleCaseStr = _.lowerCase(str)
    .split(" ")
    .map((word) => {
      if (allExceptions.indexOf(word) !== -1) {
        return word;
      } else {
        return _.capitalize(word);
      }
    })
    .join(" ");
  return tittleCaseStr;
};

const abbreviate = (str, idxCeiling = 3) => {
  return str.replace(/\s/g, "").substring(0, idxCeiling);
};

const hasEmptyDeep = (collection) => {
  if (_.isNil(collection)) {
    return true;
  }

  let arrToCheck = [];
  if (_.isObject(collection)) {
    arrToCheck = Object.values(collection);
  } else if (_.isArray(collection)) {
    arrToCheck = collection;
  }

  let ret = [_.isEmpty(arrToCheck)];
  arrToCheck.forEach((val) => {
    if (_.isObject(val) || _.isArray(val)) {
      ret.push(hasEmptyDeep(val));
    } else if (!_.isNumber(val)) {
      ret.push(_.isEmpty(val));
    }
  });

  return ret.some(Boolean);
};

const getContrastText = (hex) => {
  let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) {
    return "#FFFFFF";
  }

  let red = parseInt(result[1], 16);
  let green = parseInt(result[2], 16);
  let blue = parseInt(result[3], 16);

  if (red * 0.299 + green * 0.587 + blue * 0.114 > 186) {
    return "#000000";
  } else {
    return "#FFFFFF";
  }
};

const formatImagePositionStr = (str) => {
  if (_.isEmpty(str)) return;

  const [x, y] = str.split(",");
  return `${x}% ${y}%`;
};

const isExternal = (urlStr = "") => {
  if (_.isNil(urlStr)) {
    return false;
  }

  return ["http://", "https://", "mailto:", "tel:"].some((externalPrefix) =>
    urlStr.startsWith(externalPrefix)
  );
};

const hasPassed = (date) => {
  return moment().diff(date) >= 0;
};

const getStats = (inningStats) => {
  let inningRuns = { home: [], away: [] };
  let score = { home: "", away: "" };
  let hits = { home: "", away: "" };
  let errors = { home: "", away: "" };

  const homeInningStats = _.get(inningStats, "home", "");
  let homeInningRuns = [],
    homeHits = "",
    homeErrors = "";

  if (!_.isEmpty(homeInningStats)) {
    const [homeInningRunsStr, homeHitsErrorsStr] = homeInningStats.split("|");
    homeInningRuns = homeInningRunsStr.split(",");
    [homeHits, homeErrors] = homeHitsErrorsStr.split(",");
  }

  const awayInningStats = _.get(inningStats, "away", "");

  let awayInningRuns = [],
    awayHits = "",
    awayErrors = "";

  if (!_.isEmpty(awayInningStats)) {
    const [awayInningRunsStr, awayHitsErrorsStr] = awayInningStats.split("|");
    awayInningRuns = awayInningRunsStr.split(",");
    [awayHits, awayErrors] = awayHitsErrorsStr.split(",");
  }

  if (!_.isEmpty(homeInningRuns) && !_.isEmpty(awayInningRuns)) {
    score = {
      home: sumInningRuns(homeInningRuns),
      away: sumInningRuns(awayInningRuns),
    };
  }
  inningStats = { home: homeInningRuns, away: awayInningRuns };
  hits = { home: homeHits, away: awayHits };
  errors = { home: homeErrors, away: awayErrors };

  return { inningRuns, score, hits, errors };
};

const sumInningRuns = (inningRunsArr) => {
  return inningRunsArr.reduce((partialSum, runs) => {
    if (!isNaN(runs)) {
      partialSum += parseInt(runs);
    }
    return partialSum;
  }, 0);
};

const getNextGame = (games) => {
  const currentDate = moment();

  let upcomingGames = games.filter((game) => {
    // end of the game is approximately 3 hours after the scheduled time
    const gameDate = moment(game.frontmatter.date).add(3, "hours");
    return currentDate.isBefore(gameDate);
  });
  // get most recent 1 game
  return _.get(upcomingGames.slice(0, 1), "0");
};

const getNextEvent = (events) => {
  const currentDate = moment();
  let upcomingEvent = events.filter((event) => {
    const { endDate } = event.node.frontmatter;
    return currentDate.isBefore(moment(endDate));
  });

  return _.get(upcomingEvent.slice(0, 1), "0");
};

// in place mutation
const addNumberSuffix = (games, isEdge = false) => {
  let path = isEdge ? "node.frontmatter" : "frontmatter";
  const gamesByTeamDate = _.groupBy(games, (node) => {
    const { homeTeam, awayTeam, date } = _.get(node, path, {});
    return `${awayTeam}|${homeTeam}|${moment(date)
      .tz(TZ)
      .format("YYYY-MM-DD")}`;
  });
  const counterDict = {};
  games.forEach((node) => {
    const { homeTeam, awayTeam, date } = _.get(node, path, {});
    const teamDateKey = `${awayTeam}|${homeTeam}|${moment(date)
      .tz(TZ)
      .format("YYYY-MM-DD")}`;
    const sameTeamsHasMultiple =
      _.get(gamesByTeamDate, [teamDateKey], []).length > 1;

    if (sameTeamsHasMultiple) {
      if (teamDateKey in counterDict) {
        counterDict[teamDateKey]++;
      } else {
        counterDict[teamDateKey] = 1;
      }
      _.set(node, `${path}.numberSuffix`, counterDict[teamDateKey]);
    }
  });
};

const extractContentInsideBrackets = (str) => {
  const match = str.match(/\((.*?)\)/);
  return match ? match[1] : undefined;
};

const getFilteredEventsAndGamesByDate = (
  games = [],
  events = [],
  currentDate,
  timezone
) => {
  let filteredGames = games.filter((game) => {
    const { date } = game.node.frontmatter;
    let match = true;
    const gameDate = moment.tz(date, timezone);
    // filter month
    const monthValue = moment.tz(currentDate, timezone).month();
    if (gameDate.month() !== monthValue) {
      match = false;
    }
    return match;
  });
  let filteredEvents = events.filter((event) => {
    const { startDate, endDate } = event.node.frontmatter;
    let match = true;
    // filter month
    const monthValue = moment.tz(currentDate, timezone).month();
    const eventStartDate = moment.tz(startDate, timezone);
    const eventEndDate = moment.tz(endDate, timezone);
    if (
      eventStartDate.month() > monthValue ||
      eventEndDate.month() < monthValue
    ) {
      match = false;
    }
    return match;
  });

  return {
    dateFilteredGames: filteredGames,
    dateFilteredEvents: filteredEvents,
  };
};

const getFilteredEventsAndGames = (
  games = [],
  events = [],
  filters,
  currentDate,
  timezone,
  teamsByName,
  homeTeams = []
) => {
  let filteredGames = games.filter((game) => {
    const { homeTeam, date, awayTeam, competition } = game.node.frontmatter;
    let match = true;
    const gameDate = moment.tz(date, timezone);

    // filter day of the week
    if (!_.isNil(filters.weekday)) {
      const gameWeekday = gameDate.day();
      if (gameWeekday !== filters.weekday.value) {
        match = false;
      }
    }

    // filter home game
    const homeGame = homeTeams.includes(_.toLower(homeTeam));
    if (!_.isNil(filters.homeAway)) {
      if (homeGame !== filters.homeAway.value) {
        match = false;
      }
    }

    // filter opponent
    const opposingTeam = homeGame ? awayTeam : homeTeam;
    if (!_.isNil(filters.opponent)) {
      if (opposingTeam !== filters.opponent.value) {
        match = false;
      }
    }

    // filter promo
    // if (!_.isNil(filters.promo)) {
    //   if (promoGame !== filters.promo.value) {
    //     match = false
    //   }
    // }

    // filter location
    if (!_.isNil(filters.location)) {
      const location = _.get(
        teamsByName[homeTeam],
        "node.frontmatter.location.town"
      );
      if (location !== filters.location.value) {
        match = false;
      }
    }

    // filter league
    if (!_.isNil(filters.league)) {
      if (competition !== filters.league.value) {
        match = false;
      }
    }

    return match;
  });
  const hasFilter =
    Object.values(filters).filter((value) => value !== null).length !== 0;

  let filteredEvents = hasFilter ? [] : events;

  const filteredGamesByTeamDate = _.groupBy(filteredGames, ({ node }) => {
    const { homeTeam, awayTeam, date } = _.get(node, "frontmatter", {});
    return `${awayTeam}|${homeTeam}|${moment(date)
      .tz(TZ)
      .format("YYYY-MM-DD")}`;
  });

  return { filteredGames, filteredEvents, filteredGamesByTeamDate };
};

const getOpponentOptions = (games, homeTeams) => {
  const teamNames = games.map((g) => {
    const { homeTeam, awayTeam } = g.node.frontmatter;
    const homeGame = homeTeams.includes(_.toLower(homeTeam));
    const opposingTeam = homeGame ? awayTeam : homeTeam;
    return opposingTeam;
  });
  const uniqueTeamNames = _.uniq(teamNames);
  return uniqueTeamNames.map((name) => ({ value: name, label: name }));
};

const getLocationOptions = (games, teamsByName) => {
  const gamesWithUniqueHomeTeam = _.uniqBy(
    games,
    (game) => game.node.frontmatter.homeTeam
  );

  const locationOptions = gamesWithUniqueHomeTeam.map((game) => {
    const { homeTeam } = game.node.frontmatter;
    const homeTeamDoc = teamsByName[homeTeam];

    const location = _.get(homeTeamDoc, "node.frontmatter.location.town", "");
    const fieldName = _.get(
      homeTeamDoc,
      "node.frontmatter.location.fieldName",
      ""
    );
    return {
      value: location,
      label: `${fieldName} ${location}`,
    };
  });

  const uniqueLocationOptions = _.uniqBy(
    locationOptions,
    (option) => option.label
  );

  return uniqueLocationOptions;
};

const getLeagueOptions = (games) => {
  const gamesWithUniqueHomeTeam = _.uniqBy(
    games,
    (game) => game.node.frontmatter.competition
  );
  const leagueOptions = gamesWithUniqueHomeTeam.map((game) => ({
    value: game.node.frontmatter.competition,
    label: game.node.frontmatter.competition,
  }));
  return leagueOptions;
};

exports.titleCase = titleCase;
exports.abbreviate = abbreviate;
exports.hasEmptyDeep = hasEmptyDeep;
exports.getContrastText = getContrastText;
exports.formatImagePositionStr = formatImagePositionStr;
exports.isExternal = isExternal;
exports.hasPassed = hasPassed;
exports.getStats = getStats;
exports.getNextGame = getNextGame;
exports.getNextEvent = getNextEvent;
exports.addNumberSuffix = addNumberSuffix;
exports.extractContentInsideBrackets = extractContentInsideBrackets;
exports.getFilteredEventsAndGamesByDate = getFilteredEventsAndGamesByDate;
exports.getFilteredEventsAndGames = getFilteredEventsAndGames;
exports.getOpponentOptions = getOpponentOptions;
exports.getLocationOptions = getLocationOptions;
exports.getLeagueOptions = getLeagueOptions;
